var map = {
	"./meta.json": "6572",
	"./views/contacts.json": "fa75",
	"./views/e-appeal.json": "6ba4",
	"./views/home.json": "e908",
	"./views/news.json": "f142",
	"./views/projects.json": "4649"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a16";